class WorkbookController {
  constructor() {
    'ngInject';
  }
}

export default WorkbookController;



// WEBPACK FOOTER //
// ./client/app/modules/site/workbook/workbook.controller.js